module.exports = __webpack_public_path__ + "static/img/model.78358c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/model.png
// module id = w87U
// module chunks = 1